import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 24, restDelta: 0.001 });
  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-[70] h-[2px] origin-left"
      style={{ scaleX, background: "linear-gradient(90deg, #248A7A, #51DABE)" }}
      data-testid="scroll-progress-bar"
    />
  );
}
